module.exports = __webpack_public_path__ + "static/media/Screenshot_5.6c113c94.png";